import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const LOGO_URL = '/logo.png';

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ employeeId: '', pin: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/auth/login', form);
      localStorage.setItem('au_token', res.data.token);
      localStorage.setItem('au_user', JSON.stringify(res.data.user));
      const user = res.data.user;
      if (user.mustChangePIN) {
        navigate('/change-pin');
      } else {
        navigate(user.role === 'owner' ? '/owner/dashboard' : '/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card fu">
        <div className="login-logo-wrap">
          <img src={LOGO_URL} alt="Amravati Urban Logo" className="login-logo-img" />
          <div className="login-brand">
            <span className="au-amravati">Amravati</span>
            <span className="au-urban"> Urban</span>
          </div>
          <div className="login-sub">Co-Op Credit Society</div>
        </div>

        <div className="login-title">Sign in to your account</div>

        {error && <div className="error-msg" data-testid="login-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Employee ID</label>
            <input
              className="form-input"
              type="text"
              placeholder="e.g. admin or AGENT"
              value={form.employeeId}
              onChange={e => setForm(p => ({ ...p, employeeId: e.target.value }))}
              required
              autoFocus
              data-testid="employee-id-input"
            />
          </div>
          <div className="form-group">
            <label className="form-label">PIN</label>
            <input
              className="form-input"
              type="password"
              placeholder="4–6 digit PIN"
              value={form.pin}
              onChange={e => setForm(p => ({ ...p, pin: e.target.value }))}
              inputMode="numeric"
              maxLength={6}
              required
              data-testid="pin-input"
            />
          </div>
          <button
            className="sub-btn"
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            style={{ marginTop: '8px' }}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '11.5px', color: 'var(--g3)' }}>
          New agent? Contact your manager to get your credentials.
        </div>
      </div>
    </div>
  );
}
